const getCurrentNetwork = (networks, chainId) => {
  return networks.find((network) => network.chainId === chainId);
};

export default getCurrentNetwork;
